/* legacy-carousel.js — Reviews rail ("What Owners Are Saying")
   Fix: the previous version animated rail.scrollLeft frame-by-frame, which the
   rail's `scroll-snap-type: x mandatory` cancels — so the arrows stalled on
   desktop. This version drops snap (at !important priority) during any
   programmatic move, then restores it so cards re-snap. Adds click-and-drag /
   swipe on desktop. Mobile keeps native touch scrolling. Design unchanged. */
(function () {
  function init() {
    var rail = document.getElementById("lhp-reviews-rail");
    if (!rail || rail.dataset.lcReady) return;
    rail.dataset.lcReady = "1";

    var wrapper = rail.parentElement;
    var prev = wrapper.querySelector(".lhp-reviews-btn--prev");
    var next = wrapper.querySelector(".lhp-reviews-btn--next");

    function cardPitch() {
      var card = rail.children[0];
      if (!card) return Math.round(rail.clientWidth * 0.9);
      var w = card.getBoundingClientRect().width;
      var cs = getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap || "0") || 0;
      return Math.round(w + gap);
    }
    function maxScroll() { return rail.scrollWidth - rail.clientWidth; }

    var snapTimer;
    function scrollToPos(target) {
      target = Math.max(0, Math.min(target, maxScroll()));
      rail.style.setProperty("scroll-snap-type", "none", "important");
      rail.scrollTo({ left: target, behavior: "smooth" });
      clearTimeout(snapTimer);
      snapTimer = setTimeout(function () {
        rail.style.removeProperty("scroll-snap-type");
        updateBtns();
      }, 450);
    }

    function updateBtns() {
      if (!prev || !next) return;
      var atStart = rail.scrollLeft <= 2;
      var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      prev.style.opacity = atStart ? "0.35" : "0.92";
      next.style.opacity = atEnd ? "0.35" : "0.92";
    }

    if (prev) prev.addEventListener("click", function () { scrollToPos(rail.scrollLeft - cardPitch()); });
    if (next) next.addEventListener("click", function () { scrollToPos(rail.scrollLeft + cardPitch()); });
    rail.addEventListener("scroll", updateBtns, { passive: true });
    updateBtns();

    /* ---- Click-and-drag / swipe to slide (desktop pointer) ---- */
    var dragging = false, startX = 0, startLeft = 0, moved = false;

    rail.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "touch") return;
      dragging = true; moved = false;
      startX = e.clientX; startLeft = rail.scrollLeft;
      rail.style.setProperty("scroll-snap-type", "none", "important");
      rail.style.cursor = "grabbing";
      rail.style.userSelect = "none";
      try { rail.setPointerCapture(e.pointerId); } catch (err) {}
    });
    rail.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      rail.scrollLeft = startLeft - dx;
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      rail.style.cursor = "grab";
      rail.style.userSelect = "";
      rail.style.removeProperty("scroll-snap-type");
      updateBtns();
    }
    rail.addEventListener("pointerup", endDrag);
    rail.addEventListener("pointercancel", endDrag);
    rail.addEventListener("click", function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    rail.style.cursor = "grab";
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();